<script lang="ts" setup>
import { onBeforeUnmount, toRefs, watch } from "vue";
import { fixBody } from "@/shared/helper/fixBody";

const props = defineProps<{
  isVisible: boolean;
  hasRightContent?: boolean;
  isNestedDrawerOverlay?: boolean;
}>();

const { isNestedDrawerOverlay } = toRefs(props);
defineEmits<{
  (e: "overlay-clicked"): void;
}>();

watch(
  () => props.isVisible,
  (isVisible) => {
    // The overlay of parent drawers control body scroll (nested drawers inherit the fixed state)
    if (!isNestedDrawerOverlay.value) fixBody(isVisible);
  },
);

onBeforeUnmount(() => {
  if (!isNestedDrawerOverlay.value) fixBody(false);
});
</script>

<template>
  <teleport to="body">
    <div
      v-if="isVisible"
      class="overlay"
      :data-has-right-content="hasRightContent"
    >
      <!--Eslint wants us to add a keydown event for accessibility reasons. This does not
    make sense here however, as this is a strictly visual feature.-->
      <!-- eslint-disable vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
      <div
        class="overlay--backdrop"
        data-testid="overlay-backdrop"
        @click.prevent="$emit('overlay-clicked')"
      ></div>
      <!-- eslint-enable -->
      <slot></slot>
    </div>
  </teleport>
</template>

<style scoped>
@import "Overlay.css";
</style>
